export const addItemFormStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},

	title: {
		display: 'flex',
		gap: '12px',
		marginBottom: '12px',
		'& > :first-of-type': {
			color: 'var(--neutral-900)',
		},
		'& > :last-of-type': {
			color: 'var(--neutral-300)',
		},
	},

	upload: {
		display: 'flex',
		gap: '25px',
		marginBottom: '40px',
		height: '140px',
	},

	content: {
		display: 'flex',
		gap: '24px',
	},

	contentItem: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		width: '100%',
	},

	category: {
		width: '100%',
		//maxWidth: '274px',
	},

	categoryValidation: {
		'& .MuiFormHelperText-root': {
			bottom: '-18px',
			left: '158px',
			right: 'unset',
		},
	},

	description: {
		maxWidth: '100%',

		'&.MuiFormControl-root .MuiInputBase-root': {
			height: '100%',
			maxHeight: '218px',
			padding: '15px 12px',
		},
	},

	liveAuction: {
		display: 'flex',
		gap: '40px',
	},

	radioTitle: {
		fontWeight: 400,
	},

	amountWrapper: {
		display: 'flex',
		gap: '12px',
	},

	amount: {
		'& .MuiInputBase-input': {
			padding: '0 12px 0 0 !important',
		},
	},

	donorTitle: {
		marginBottom: '4px',
		marginTop: '40px',
		textAlign: 'center',
	},

	addDonorButton: {
		marginRight: 'auto',
	},
};
